import styled from 'styled-components';

import { ChatConversation } from 'services/api/chat';
import { colors } from 'styles/theme/colors';
import { FONT_WEIGHT_MEDIUM } from 'styles/theme/textStyles';
import { BodySmall } from 'styles/typography';

type Props = {
  conversation: ChatConversation;
  selected: boolean;
  onSelect: (conversationId: string) => void;
};

// A single facility row in the channel rail. Unread badges arrive in the unread story
// (OLIO-2834) — v1 shows the facility name only.
export default function ChannelListItem({ conversation, selected, onSelect }: Props) {
  return (
    <Row
      type='button'
      $selected={selected}
      aria-current={selected}
      data-testid='chat-channel-item'
      onClick={() => onSelect(conversation.id)}>
      <Name $selected={selected}>{conversation.audience.name}</Name>
    </Row>
  );
}

const Row = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 9px 12px;
  border-radius: 6px;
  background: ${({ $selected }) => ($selected ? colors.blue10 : 'transparent')};

  &:hover {
    background: ${({ $selected }) => ($selected ? colors.blue10 : colors.black3)};
  }
`;

const Name = styled(BodySmall)<{ $selected: boolean }>`
  color: ${({ $selected }) => ($selected ? colors.blue100 : colors.black100)};
  font-weight: ${({ $selected }) => ($selected ? FONT_WEIGHT_MEDIUM : 'inherit')};
`;
